import apiClient from '@/services/axios'

export async function post(venueSetupId, venueSectionId, table) {

  var response = await apiClient.post(process.env.VUE_APP_MARCOM_API_BASE_URL + '/admin/venue-setups/' + venueSetupId + '/venue-sections/' + venueSectionId + '/venue-tables', table);

  if (response) {
    console.log(response)
    return response.data;
  }

  throw new Error('Unable to get Team Members.')
}
